if (document.getElementById('page-cart')) {
  pageCart()
}
function pageCart() {
  //   ####   ####  #####     #####   ##      ##
  //  ##     ##     ##  ##   ##   ##  ##      ##
  //   ###   ##     #####    ##   ##  ##      ##
  //     ##  ##     ##  ##   ##   ##  ##      ##
  //  ####    ####  ##   ##   #####   ######  ######

  /**
   * @function scrollValToggle
   * @description スクロール量を基準にクラスを着脱する
   * @param {String} targetSelector ターゲットとする一意なセレクタ
   * @param {Number} scrollValStart 有効範囲となるスクロール量　上からの距離
   * @param {Number|Boolean} [scrollValEnd=false] 有効範囲外となるスクロール量　下からの距離
   * @param {String} toggleClass 切り替えるクラス名
   * @return {Void}
   */
  scrollValToggle('#cartSend', 0, 100, 'active')
  function scrollValToggle(targetSelector, scrollValStart = 500, scrollValEnd = false, toggleClass = 'active') {
    if (!document.querySelector(targetSelector)) {
      return
    }
    let isExecute = false // 実行中フラグ
    let scrollY = 0 // 縦方向のスクロール量
    const target = document.querySelector(targetSelector) // ターゲット要素
    let scToggleActive = false // ターゲット要素のONOFF状態
    document.addEventListener('scroll', function (ev) {
      scrollValToggleApply()
    })
    scrollValToggleApply() // 初回起動
    function scrollValToggleApply() {
      if (isExecute) {
        // 実行中ならスキップ
        return
      }
      isExecute = true
      // レンダリング準備が整ったら開始
      requestAnimationFrame(function () {
        scrollY = window.scrollY // スクロール量
        if (scrollY >= scrollValStart && !scToggleActive) {
          //トップから指定px以上スクロールしたらON
          target.classList.add(toggleClass)
          scToggleActive = true
        } else if (scrollY < scrollValStart && scToggleActive) {
          //スクロールが足りない時はOFF
          target.classList.remove(toggleClass)
          scToggleActive = false
        }
        if (scrollValEnd && scToggleActive) {
          // 終了ラインが設定されている場合は終了判定

          if (scrollY + window.innerHeight > document.documentElement.scrollHeight - scrollValEnd) {
            //スクロール終了範囲を過ぎていたらOFF
            target.classList.remove(toggleClass)
            scToggleActive = false
          }
        }
        isExecute = false
      })
    }
  }

  //  ####    #####  ##
  //  ##  ##  ##     ##
  //  ##  ##  #####  ##
  //  ##  ##  ##     ##
  //  ####    #####  ######

  window.addEventListener('click', function (e) {
    // 指定のクラスを持つ
    if (!e.target.classList.contains('js-cartDel')) {
      return
    }
    const target = e.target.dataset.target
    const item = document.getElementById(target)
    item.classList.add('delete')
    setTimeout(() => {
      // DOM削除
      item.parentNode.removeChild(item)
    }, 300)
  })
}
